import React from 'react';
import { Link } from 'react-router-dom';

const Navber = () => {
    return (

        <div className="px-10 py-5 grid grid-cols-2  mx-auto  bg-teal-100 ">
            <div >
                <p className=' text-xl text-rose-900 '> MCQ Test </p>
            </div>
           
                <ul className="items-stretch   md:flex justify-end md:justify-end ">
                    <li className=' items-center px-4   dark:border-transparent'>
                        <Link to='topics'>Topics </Link>
                    </li>
                    <li className=' items-center px-4  dark:border-transparent'>
                        <Link to='statistis'>Statistis </Link>
                    </li>
                    <li className=' items-center px-4  dark:border-transparent'>
                        <Link to='blog'>Blog </Link>
                    </li>
                   

                </ul>
            
        </div>

    );
};

export default Navber;